'use client';

import { Center, Paper, Stack, Title, Text, Button, Group } from '@mantine/core';
import { useRouter } from 'next/navigation';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  return (
    <Center style={{ flex: 1, height: '100vh', background: 'var(--rl-bg)' }}>
      <Paper
        p="xl"
        radius="md"
        style={{
          background: 'var(--rl-bg)',
          border: '1px solid var(--rl-border)',
          maxWidth: 420,
        }}
      >
        <Stack align="center" gap="md">
          <Title order={3} style={{ color: 'var(--rl-fg)' }}>
            Something went wrong
          </Title>
          <Text size="sm" style={{ color: 'var(--rl-fg)', opacity: 0.7 }}>
            {error.message || 'An unexpected error occurred.'}
          </Text>
          {error.digest && (
            <Text size="xs" style={{ color: 'var(--rl-fg)', opacity: 0.4 }} ff="monospace">
              digest: {error.digest}
            </Text>
          )}
          <Group>
            <Button variant="default" onClick={reset}>
              Try again
            </Button>
            <Button variant="subtle" onClick={() => router.replace('/login')}>
              Return to login
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Center>
  );
}
